import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';

export const secondsPerMonth = 2592000;

export default class ReminderDatePicker extends React.Component {
  static propTypes = {
    reminderDifference: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
  }

  state = {
    units: 12,
    unitType: 'months'
  }

  componentDidMount() {
    this.setStateFromReminderDifference();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reminderDifference === this.props.reminderDifference) return;

    this.setStateFromReminderDifference();
  }

  setStateFromReminderDifference() {
    const { reminderDifference } = this.props;

    const months = Math.round(reminderDifference / secondsPerMonth);

    if (months % 12 !== 0) {
      this.setState({ units: months, unitType: 'months' });
    } else {
      this.setState({ units: months / 12, unitType: 'years' });
    }
  }

  renderUnitOptions() {
    return range(1, 31).map(i => <option key={i} value={i}>{i}</option>);
  }

  handleInputChange = (e) => {
    if (e.target.name === 'unit-select') {
      this.props.onChange(e.target.value * secondsPerMonth * (this.state.unitType === 'years' ? 12 : 1));
    } else {
      this.props.onChange(this.state.units * secondsPerMonth * (e.target.value === 'years' ? 12 : 1));
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="row-eq-height">
          <div className="mr-2">
            <select
              className='form-control'
              name='unit-select'
              value={this.state.units}
              onChange={this.handleInputChange}
            >
              {this.renderUnitOptions()}
            </select>
          </div>
          <div className="grow">
            <select
              className='form-control'
              name='unit-type-select'
              value={this.state.unitType}
              onChange={this.handleInputChange}
            >
              <option value={'months'}>Months</option>
              <option value={'years'}>Years</option>
            </select>
          </div>
        </div>

      </React.Fragment>
    );
  }
}
